import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class HttpFilterService {

  private serviceBaseFilter = 'model/filter/';

  constructor(private http: HttpClient) { }

  getActiveSelects(): Observable<any> {
    return this.http.get(this.serviceBaseFilter + 'getActiveSelects');
  }

  getControlSum(): Observable<any> {
    return this.http.get(this.serviceBaseFilter + 'getActiveSelectsControlSum');
  }

  /** Odtud dále jsou relevantní funkce */

  getSelectByAlias(alias: string): Observable<any> {
    const aliasObj = {alias};
    return this.http.post(this.serviceBaseFilter + 'getSelectByAlias', aliasObj);
  }

  getSelectOptionByAliasAndFiltres(sendThis: { alias: string; filters: Array<any> }): Observable<any> {
    return this.http.post(this.serviceBaseFilter + 'getSelectOptionByAliasAndFilters', sendThis);
  }

  getEndYearSelect(): Observable<any> {
    return this.http.get(this.serviceBaseFilter + 'getEndYearSelect');
  }
}
